<script>
  import template from '@/components/views/template'

  import DATA from '@/data/aboutUs'
  const ORG = DATA['org']

  export default {
    name: 'inforDis',
    components: {
    },
    filters: {
    },
    mixins: [template],
    props: {
    },
    data() {
      return {
        dbList: []
      }
    },
    computed: {
    },
    watch: {
    },
    created() {
      const {
        dbList
      } = this
      this.dbList = dbList.concat(ORG)
    },
    mounted() {

    }
  }
</script>

<template>
  <div class="container-wrap">
    <navigation></navigation>
    <div class="main-center" id="jgfb">
      <div class="main-container">
        <article class="distributed anchor-title">
          <div class="hd">
            <h3>机构分布</h3>
            <p><span>DISTRIBUTED</span></p>
          </div>
          <div class="bd">
            <div class="distributed-box">
              <table class="table distributed-table">
                <tr>
                  <th>机构名称</th>
                  <th><p>行政<br />直辖区</p></th>
                  <th>机构编码</th>
                  <th>成立时间</th>
                  <th>机构住所</th>
                  <th>所属监管</th>
                </tr>
                <tr v-for="(item, index) in dbList"
                  :key="index">
                  <td v-html="item.orgNames"></td>
                  <td v-html="item.district"></td>
                  <td v-html="item.orgCode"></td>
                  <td v-html="item.foundedTime"></td>
                  <td v-html="item.address"></td>
                  <td v-html="item.supervision"></td>
                </tr>
              </table>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="main-center container-bg">
      <div class="main-container">
        <div class="anchor-point" id="lxwm"></div>
        <article class="contact-us anchor-title">
          <div class="hd">
            <h3>联系我们</h3>
            <p><span>CONTACT US</span></p>
          </div>
          <div class="bd">
            <div class="contact-us-box">
              <div class="contact-map">
                <div class="wy" id="wy-bxs"></div>
              </div>
              <div class="address">
                <div class="inner">
                  <p>地址：北京市西城区德胜门外大街36号楼5层2单元512</p>
                  <p>客服热线：010-50949729</p>
                  <p>投诉建议：010-50949729</p>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
    <nav-footer class="main-center"></nav-footer>
  </div>
</template>

<style>
  @import 'reset';
  @import 'base';
  @import 'layout';
  @import 'variable';
  @import './index';

  #jgfb {
    padding-top: 96px;
  }

  .anchor-point {
    z-index: -1;
    position: absolute;
    margin-top: -96px;
  }
</style>
